document.addEventListener('DOMContentLoaded', function () {

  async function checkMembershipCart() {

    const cart = await fetch('/cart.js')
      .then(res => res.json());

    const membership = cart.items.find(item =>
      item.properties &&
      item.properties._auto_membership === "true"
    );

    const normalProducts = cart.items.filter(item =>
      !(item.properties && item.properties._auto_membership === "true")
    );

    // Remove membership if no products remain
    if (membership && normalProducts.length === 0) {

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: membership.key,
          quantity: 0
        })
      });

      window.location.reload();
    }
  }


  // Listen for remove button clicks
  document.addEventListener('click', function(e){

    if(
      e.target.closest('.scd-item__remove')
    ){
      setTimeout(() => {
        checkMembershipCart();
      }, 1000);
    }

  });


});